export default __webpack_public_path__ + "static/media/jap-ecommerceImg_3.9e7077c0.webp";